module.exports = __webpack_public_path__ + "img/plus.e3fedebb.svg";